function SandboxForecastPanel({ net, baselineNet }) {
  if (!net) return null;

  const baseNet = baselineNet ?? 0;

  const climbing   = net.forecastNet >= net.budgetNet;
  const impact     = net.forecastNet - baseNet;
  const rocColor   = climbing ? '#15803D' : '#BE123C';

  function fmt(n) {
  if (!n && n !== 0) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(n);
}

  return (
    <div style={{
      background:'#fff', borderRadius:8, padding:'1.25rem',
      boxShadow:'0 1px 3px rgba(0,0,0,0.08)',
      border:`2px solid ${rocColor}`,
      marginBottom:'1rem',
      textAlign:'center',
    }}>
      <div style={{ fontSize:'0.8rem', color:'#64748B', marginBottom:'0.5rem', fontWeight: 'bold', letterSpacing: '0.05rem' }}>
        LIVE FORECAST IMPACT
      </div>

      {/* Rate of Climb */}
      <div style={{ fontSize:'1.4rem', fontWeight:700, color:rocColor, marginBottom:'0.75rem' }}>
        {climbing ? '▲ CLIMBING' : '▼ DIVING'}
      </div>

      {/* Numbers */}
      {[
  { label:'Year Forecast Net',  value: fmt(net.forecastNet),  color:'#1B2A4A' },
  { label:'Annual Budget Net',  value: fmt(net.budgetNet),    color:'#64748B' },
  { label:'Variance vs Budget', value: (net.variance>=0?'+':'')+fmt(net.variance), color:rocColor },
  { label:'Change vs Baseline', value: (impact>=0?'+':'')+fmt(impact), color: impact>=0?'#15803D':'#BE123C' },
].map(({label,value,color})=>(
  <div key={label} style={{ display:'flex', justifyContent:'space-between',
                              padding:'0.3rem 0', borderBottom:'1px solid #F1F5F9',
                              maxWidth:320, margin:'0 auto' }}>
    <span style={{ fontSize:'0.8rem', color:'#64748B' }}>{label}</span>
    <span style={{ fontSize:'0.85rem', fontWeight:600, color }}>{value}</span>
  </div>
))}
    </div>
  );
}

export default SandboxForecastPanel;
